export function operacaoAfericaoInRequest(params = {}) {
  return {
    type: '@operacaoafericao/OPERACAOAFERICAO_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoAfericao(idoperacaoafericao) {
  return {
    type: '@operacaoafericao/FIND_OPERACAOAFERICAO',
    payload: { idoperacaoafericao },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoafericao/FAILED_REQUEST',
  };
}

export function deleteOperacaoAfericao(idoperacaoafericao, params, query = {}) {
  return {
    type: '@operacaoafericao/DELETE_OPERACAOAFERICAO',
    payload: { idoperacaoafericao, params, query },
  };
}

export function updateOperacaoAfericao(operacaoafericao, params) {
  return {
    type: '@operacaoafericao/UPDATE_OPERACAOAFERICAO',
    payload: { operacaoafericao, params },
  };
}

export function storeOperacaoAfericao(operacaoafericao, params) {
  return {
    type: '@operacaoafericao/STORE_OPERACAOAFERICAO',
    payload: { operacaoafericao, params },
  };
}

export function successInRequest(
  operacaoafericao,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaoafericao/SUCCESS_IN_REQUEST',
    payload: { operacaoafericao, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaoafericao) {
  return {
    type: '@operacaoafericao/SUCCESS_REQUEST',
    payload: { operacaoafericao },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoafericao/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoafericao/RECORD_FILTERING',
    payload: { params },
  };
}
